import { Dictionary } from '../utils/types'
import { importLazy } from '../utils/import'

import { Routes } from './routes'

const ProfilePage = importLazy(() => import('../pages/profile'))
const ProfileManagementPage = importLazy(() => import('../pages/profile-management'))
const ArchiveReportsPage = importLazy(() => import('../pages/ArchiveReports'))
const AccountingPage = importLazy(() => import('../pages/accounting'))
const TransactionsPage = importLazy(() => import('../pages/transactions'))
const ArchiveNotificationsPage = importLazy(() => import('../pages/ArchiveNotifications'))
const AccountActivationPage = importLazy(() => import('../pages/account-activation'))
const SearchPage = importLazy(() => import('../pages/Search'))
const RegisterPage = importLazy(() => import('../pages/register'))
const CompanyDetail = importLazy(() => import('../pages/CompanyDetail'))
const InvestigationPage = importLazy(() => import('../pages/Investigation/investigation'))
const Cart = importLazy(() => import('../pages/Cart'))
const PasswordResetPage = importLazy(() => import('../pages/password-reset'))
const PasswordUpdatePage = importLazy(() => import('../pages/password-update'))
const CheckoutPage = importLazy(() => import('../pages/Checkout'))
const OrderProcessingPage = importLazy(() => import('../pages/Checkout/orderProcessing'))
const ImportPage = importLazy(() => import('../pages/Import/import'))
const ImportHistoryPage = importLazy(() => import('../pages/ImportHistory/import-history'))
const ArchiveInvoicesPage = importLazy(() => import('../pages/ArchiveInvoices'))

export type RouteOverride = {
  createConfig?: () => Dictionary<unknown>
  component: React.ElementType
}

export type RouteOverrideConfig = Record<Routes | string, RouteOverride>

export const routesComponentConfig: RouteOverrideConfig = {
  [Routes.Profile]: {
    component: ProfilePage
  },
  [Routes.ProfileManagement]: {
    component: ProfileManagementPage
  },
  [Routes.ArchiveReports]: {
    component: ArchiveReportsPage
  },
  [Routes.ArchiveInvoices]: {
    component: ArchiveInvoicesPage
  },
  [Routes.Accounting]: {
    component: AccountingPage
  },
  [Routes.Transactions]: {
    component: TransactionsPage
  },
  [Routes.ArchiveNotifications]: {
    component: ArchiveNotificationsPage
  },
  [Routes.Activation]: {
    component: AccountActivationPage
  },
  [Routes.Search]: {
    component: SearchPage
  },
  [Routes.CompanyDetail]: {
    component: CompanyDetail
  },
  [Routes.Investigation]: {
    component: InvestigationPage
  },
  [Routes.Cart]: {
    component: Cart
  },
  [Routes.PasswordReset]: {
    component: PasswordResetPage
  },
  [Routes.PasswordUpdate]: {
    component: PasswordUpdatePage
  },
  [Routes.Register]: {
    component: RegisterPage
  },
  [Routes.Checkout || Routes.Billing || Routes.Payment || Routes.Confirmation]: {
    component: CheckoutPage
  },
  [Routes.OrderProcessing]: {
    component: OrderProcessingPage
  },
  [Routes.UploadImport]: {
    component: ImportPage
  },
  [Routes.Import]: {
    component: ImportPage
  },
  [Routes.ImportHistory]: {
    component: ImportHistoryPage
  }
}
